import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';

import ResponsiveLayout from '../common/ResponsiveLayout';
import Tracker from '../common/Tracker';
import api from '../../api/api.js';
import styles from "./styles";

import searchIcon from '../../img/ic-search-dark.svg';

import '../../css/LocatorFormHeaderMobile.css';

const CATEGORY = "locator";

class LocatorFormHeaderDesktopLayout extends Component {
    render() {
        return (
            <div className="locatorFormHeader">
                <div className="locatorFormSearchBox">
                    <div style={{flex: 1, padding: "0 10px 0 8px"}}>
                        <TextField
                            hintText="City and State, or ZIP"
                            fullWidth={true}
                            underlineShow={false}
                            value={this.props.query}
                            errorText={this.props.errors.search}
                            inputStyle={{
                                color: "#1c5c7f",
                                fontWeight: 300,
                                fontFamily: "Lato",
                                fontSize: "22px",
                            }}
                            hintStyle={{
                                color: "#979a9f",
                                fontWeight: 200,
                                fontFamily: "Lato",
                                fontSize: "22px",
                            }}
                            onChange={this.props.onQueryChange}
                            onKeyDown={this.props.onSearchKeyDown} />
                    </div>
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <SelectField
                            style={{width: "120px"}}
                            labelStyle={{fontFamily: "Lato", fontSize: "15px", color: "#979a9f"}}
                            underlineShow={false}
                            value={this.props.searchRadius}
                            onChange={this.props.onSearchRadiusUpdate}>
                            {this.props.distanceOptions.map((option) => {
                                return (<MenuItem primaryText={option + " miles"} value={option} key={option}/>)
                            })}
                        </SelectField>
                    </div>
                    <div style={{width: "80px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                        {this.props.loading ?
                            <CircularProgress size={25} thickness={2} />
                            :
                            <RaisedButton
                                label="Search"
                                fullWidth={true}
                                onClick={this.props.onSearchClick}
                                labelStyle={styles.labelStyle}
                                backgroundColor={styles.buttonBackgroundColor}/>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class LocatorFormHeaderMobileLayout extends Component {
    render() {
        return (
            <div className="locator-form-search-wrapper-mobile">
                <div className="locator-form-search-container-mobile">
                    <TextField
                        value={this.props.query}
                        hintText="City and State, or ZIP"
                        fullWidth={true}
                        underlineShow={false}
                        errorText={this.props.errors.search}
                        inputStyle={{
                            color: "#1c5c7f",
                            fontFamily: "Oswald",
                            fontSize: "18px",
                            fontWeight: 300,
                        }}
                        hintStyle={{
                            color: "#979a9f",
                            fontWeight: 300,
                            fontFamily: "Oswald",
                            fontSize: "18px",
                        }}
                        onChange={this.props.onQueryChange}
                        onKeyDown={this.props.onSearchKeyDown} />

                    <IconButton
                        className="locator-form-search-button-mobile"
                        onClick={this.props.onSearchClick}>
                        <img src={searchIcon} alt="search icon" />
                    </IconButton>
                </div>
            </div>
        )
    }
}

class LocatorFormHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            distanceOptions: this.getDistanceOptions(),
            query: "",
            loading: false,
            errors: {}
        }
    }

    getDistanceOptions = () => {
        var ret = [];
        for (var i = 1; i * 5 <= 100; i++) {
            ret.push(i * 5);
        }
        return ret;
    }

    onRadiusChange = (event, index, value) => {
        this.props.onSearchUpdate({radius: value});
    }

    onQueryChange = (event, value) => {
        this.setState({query: value});
        // this.props.onSearchUpdate({query: value})
    }

    onSearchKeyDown = (event, value) => {
        if (event.keyCode === 13) {
            this.onSearchClick();
        }
    }

    onSearchClick = () => {
        if (this.state.query && this.state.query.length > 0) {
            Tracker.trackEvent(CATEGORY, "search performed", this.state.query, "");
            this.setState({loading: true});
            api.geoCodeQuery(this.state.query, (lat, lng) => {
                let errors = {};
                if (lat && lng) {
                    Tracker.trackEvent(CATEGORY, "search geocode succeeded", this.state.query, "");
                    api.trackSearchQuery(this.state.query, this.props.searchRadius, lat, lng, this.props.filter, this.props.specialties);
                    this.props.updateGeoQuery(lat, lng, null);
                } else {
                    Tracker.trackEvent(CATEGORY, "search geocode failed", this.state.query, "");
                    errors = {search: "Could not find location."}
                }
                this.setState({loading: false, errors: errors});
            });
        }
    }

    render() {
        return (
            <ResponsiveLayout
                desktopLayout={LocatorFormHeaderDesktopLayout}
                mobileLayout={LocatorFormHeaderMobileLayout}
                {...this.state}
                {...this.props}
                onSearchKeyDown={this.onSearchKeyDown}
                onSearchClick={this.onSearchClick}
                onQueryChange={this.onQueryChange}
                onRadiusChange={this.onRadiusChange} />
        )
    }
}

export default LocatorFormHeader;



// WEBPACK FOOTER //
// ./src/components/locator/LocatorFormHeader.js